const industryDataset = {
    'Software Development': {
        projectTypes: ['Agile'],
        preferredResources: [
            { name: 'Software Engineer', hourlyRate: 50, count: 3 },
            { name: 'QA Engineer', hourlyRate: 40, count: 1 },
            { name: 'Project Manager', hourlyRate: 60, count: 1 },
            { name: 'Security Engineer', hourlyRate: 55, count: 1 }
        ],
        techStack: ['React', 'Node.js', 'Java', 'Python', 'Docker', 'AWS', 'NA'],
        sprintsOrMilestones: [
            { name: 'Requirement Analysis', duration: 2 },
            { name: 'Design', duration: 2 },
            { name: 'Development', duration: 2 },
            { name: 'Testing', duration: 2 },
            { name: 'Deployment', duration: 2 },
            { name: 'Static & Dynamic Code Scan', duration: 2 },
            { name: 'Penetration Testing', duration: 2 }
        ],
        projectExpenses: [
            { item: 'Subscription', manufacturer: 'AWS', description: 'Cloud Hosting', quantity: 1, unitPrice: 500, totalCost: 500 },
            { item: 'License', manufacturer: 'Microsoft', description: 'Visual Studio', quantity: 1, unitPrice: 250, totalCost: 250 },
            { item: 'Security', manufacturer: 'Fortinet', description: 'Pentest Service', quantity: 1, unitPrice: 1000, totalCost: 1000 },
            { item: 'Static Code Scan', manufacturer: 'Veracode', description: 'Code Security Analysis', quantity: 1, unitPrice: 1200, totalCost: 1200 },
            { item: 'Dynamic Code Scan', manufacturer: 'Burp Suite', description: 'Application Security Testing', quantity: 1, unitPrice: 800, totalCost: 800 }
        ],
        taxNote: "This estimate does not include state tax.",
        comments: "",
        termsAndConditions: "Terms and Conditions - Estimates generated using SoftEstimate are based solely on the input data provided by the user. The accuracy of these estimates depends on the quality of inputs, resource capabilities, project execution, and management processes. The success of any project relies on factors such as team expertise, execution quality, risk management, and unforeseen challenges.Users are responsible for validating and refining estimates before making business decisions. SoftEstimate is provided 'as-is' with no express or implied warranties. Users should periodically revalidate estimates as project conditions evolve. ",
        estimatePreparedBy: "Prepared By - ...",
        estimatePreparedFor: "Prepared For - ..."
    },
    'House Remodeling': {
        projectTypes: ['Waterfall'],
        preferredResources: [
            { name: 'Carpenter', hourlyRate: 35, count: 1 },
            { name: 'Electrician', hourlyRate: 45, count: 1 },
            { name: 'Plumber', hourlyRate: 40, count: 1 },
            { name: 'Architect', hourlyRate: 70, count: 1 }
        ],
        techStack: ['AutoCAD', 'Revit', 'SketchUp', 'NA'],  // Added relevant software for remodeling.        
        sprintsOrMilestones: [
            { name: 'Planning & Design', duration: 3 },
            { name: 'Demolition', duration: 2 },
            { name: 'Construction', duration: 6 },
            { name: 'Finishing', duration: 4 },
            { name: 'City Inspection', duration: 2 }
        ],
        projectExpenses: [
            { item: 'Lumber', manufacturer: 'Home Depot', description: 'Wood for framing', quantity: 50, unitPrice: 10, totalCost: 500 },
            { item: 'Electrical Wiring', manufacturer: 'Siemens', description: 'Electrical components', quantity: 20, unitPrice: 15, totalCost: 300 },
            { item: 'Plumbing Pipes', manufacturer: 'PVC Co.', description: 'Water supply pipes', quantity: 30, unitPrice: 12, totalCost: 360 },
            { item: 'Building Permits', manufacturer: 'City Council', description: 'Construction Permit', quantity: 1, unitPrice: 200, totalCost: 200 },
            { item: 'City Inspection', manufacturer: 'Local Authority', description: 'Structural & Safety Inspection', quantity: 1, unitPrice: 500, totalCost: 500 }
        ],
        taxNote: "This estimate does not include state tax.",
        comments: "",
        termsAndConditions: "Terms and Conditions - Estimates generated using SoftEstimate are based solely on the input data provided by the user. The accuracy of these estimates depends on the quality of inputs, resource capabilities, project execution, and management processes. The success of any project relies on factors such as team expertise, execution quality, risk management, and unforeseen challenges.Users are responsible for validating and refining estimates before making business decisions. SoftEstimate is provided 'as-is' with no express or implied warranties. Users should periodically revalidate estimates as project conditions evolve. ",
        estimatePreparedBy: "Prepared By - ...",
        estimatePreparedFor: "Prepared For - ..."
    },
    'General Contracting': {
        projectTypes: ['Waterfall'],
        preferredResources: [
            { name: 'General Contractor', hourlyRate: 80, count: 1 },
            { name: 'Project Manager', hourlyRate: 75, count: 1 },
            { name: 'Civil Engineer', hourlyRate: 85, count: 1 },
            { name: 'Construction Worker', hourlyRate: 30, count: 4 },
            { name: 'Safety Inspector', hourlyRate: 50, count: 1 }
        ],
        techStack: ['AutoCAD', 'Primavera P6', 'Revit', 'Bluebeam', 'NA'],
        sprintsOrMilestones: [
            { name: 'Planning & Approval', duration: 1 }
        ],
        projectExpenses: [
            { item: 'Concrete', manufacturer: 'CEMEX', description: 'Foundation Material', quantity: 100, unitPrice: 120, totalCost: 12000 },
            { item: 'Structural Steel', manufacturer: 'SteelCo', description: 'Framing Material', quantity: 50, unitPrice: 300, totalCost: 15000 },
            { item: 'Electrical Components', manufacturer: 'Schneider Electric', description: 'Switches, Wiring, Breakers', quantity: 40, unitPrice: 50, totalCost: 2000 },
            { item: 'Plumbing Fixtures', manufacturer: 'Kohler', description: 'Pipes, Valves, Fittings', quantity: 30, unitPrice: 80, totalCost: 2400 },
            { item: 'Safety Equipment', manufacturer: '3M', description: 'Helmets, Gloves, Vests', quantity: 20, unitPrice: 30, totalCost: 600 }
        ],
        taxNote: "This estimate does not include state tax.",
        comments: "",
        termsAndConditions: "Terms and Conditions - Estimates generated using SoftEstimate are based solely on the input data provided by the user. The accuracy of these estimates depends on the quality of inputs, resource capabilities, project execution, and management processes. The success of any project relies on factors such as team expertise, execution quality, risk management, and unforeseen challenges.Users are responsible for validating and refining estimates before making business decisions. SoftEstimate is provided 'as-is' with no express or implied warranties. Users should periodically revalidate estimates as project conditions evolve. ",
        estimatePreparedBy: "Prepared By - ...",
        estimatePreparedFor: "Prepared For - ..."
    }
};

export default industryDataset;
